import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Scrolls to the very top of the page on push/replace navigation.
 * Skips POP (back/forward) so useScrollRestore can restore the position.
 * Temporarily disables CSS smooth-scroll so the jump is instant and crisp.
 */
export default function RouteScrollToTop() {
  const { pathname } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (navType === "POP") return;
    const html = document.documentElement;
    html.classList.add("lov-scroll-jump");
    // Two rAFs: let the new route mount/layout before scrolling
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.scrollTo(0, 0);
        html.classList.remove("lov-scroll-jump");
      });
    });
  }, [pathname, navType]);

  return null;
}
